'use strict';

angular.module('rmCampaign')
	.directive('campaignScheduleDay', ['$http', '$state', '$timeout',
		function($http, $state, $timeout) {

			let $document = $(document);

			let minutesInADay = 1440; // 24x60
			let hourHeight = 70; // 70px .TimeTime box height
			let minuteHeight = hourHeight / 60;
			let minuteHeightDivided = minuteHeight / 100;

			function getMinutes(time) {
				return (time.hour() * 60) + time.minute();
			}

			function renderBlocks(blocks, zoomFactor) {
				let rows = [
					[]
				];

				blocks.forEach((block, i) => {
					// Calculate zoom heights
					let minuteHeightWithZoom = (minuteHeightDivided) * zoomFactor;
					block._start = moment.tz(block.start, window.CONFIG.timezone);
					block._stop = moment.tz(block.stop, window.CONFIG.timezone);

					let startMinute = getMinutes(block._start);
					let stopMinute = getMinutes(block._stop);
					stopMinute = stopMinute === 0 ? minutesInADay : stopMinute;
					block._y = Math.round(startMinute * minuteHeightWithZoom);
					block._h = Math.round((stopMinute - startMinute) * minuteHeightWithZoom);

					block._collide = false;

					blocks.forEach((b) => {
						blocks.forEach((k) => {
							if (b == k) return;
							if (collides(b, k)) {
								b._collide = true;
							}
						});
					});

					// Loop until we find a row which doesn't have blocks colliding
					let nextRow = true;
					while (nextRow) {
						for (let i = 0, l = rows.length + 1; i < l; i++) {
							let goNext = false;
							let row = rows[i];
							for (let i = 0, l = row.length; i < l; i++) {
								let value = row[i];
								if (collides(block, value)) {
									goNext = true;
									break;
								}
							}
							if (goNext) {
								// If its the last row and a new one
								if (i + 1 === rows.length) {
									rows.push([]);
								}
								continue;
							}
							nextRow = false;
							row.push(block);
							break;
						}
					}
				});

				let w = 100 / rows.length;
				rows.forEach((row, i) => {
					let offset = i * w;
					row.forEach((block) => {
						block._x = offset + '%';
						block._w = w + '%';
					});
				});

				if (rows.length > 1) {
					rows[0].forEach((block) => {
						if (!block._collide) {
							block._x = '0%';
							block._w = '100%';
						}
					});
				}
			}

			function collides(value, item) {
				return ((value.start == item.start) || // Same start
					(value.stop == item.stop) || // Same end
					(value._start > item._start && value._start < item._stop) || // Value start inbetween item
					(value._stop > item._start && value._stop < item._stop) || // Value stop inbetween item
					(item._start > value._start && item._start < value._stop) || // Item start inbetween value
					(item._stop > value._start && item._stop < value._stop) // Item stop inbetween value
				);
			}

			return {
				restrict: 'E',
				scope: {
					refresh: '=scheduleRefreshTrigger',
					zoom: '=scheduleZoom',
					date: '=scheduleDate',
					blocks: '=scheduleBlocks',
					_add: '=scheduleAdd',
					_subtract: '=scheduleSubtract',
					campaignId: '=scheduleCampaignId',
					campaign: '=scheduleCampaign',
					additions: '=scheduleAdditions'
				},
				templateUrl: '/partial/app.partials.campaign.schedule_day',
				link: function(scope, element, attrs) {

					// Init
					$timeout(() => {
						renderBlocks(scope.blocks, scope.zoom);
					});

					// Watchers
					scope.$watch('zoom', () => {
						renderBlocks(scope.blocks, scope.zoom);
					});

					// refresh trigger
					scope.$watch('refresh', () => {
						for (let i = 0, l = scope.blocks.length; i < l; i++) {
							let block = scope.blocks[i];
							block._count = block.campaigns_count
												.filter((c) => c.campaign_id == scope.campaignId)
												.reduce((old, c) => c.count, 0);

							block._count += scope.additions.add.filter((id) => block.id === id).length;
							block._count -= scope.additions.remove.filter((id) => block.id === id).length;
						}
						renderBlocks(scope.blocks, scope.zoom);
					});

					scope.$on('$destroy', () => {
						//
					});

					scope.add = function(block){
						block._count++;
						scope._add(block.id);
					};

					scope.subtract = function(block){
						if (block._count > 0){
							block._count--;
							scope._subtract(block.id);
						}
					};

					scope.otherCampaignsCount = function(campaigns, campaignId){
						let count = 0;
						campaigns.forEach((campaign) => {
							if(campaign.campaign_id != campaignId) count++;
						});

						return count;
					}
				}
			};
		}
	]);

